import React, { useEffect } from 'react'

function AutoLogout() {
    useEffect(() => {
        localStorage.setItem('h-token_type', '');
        localStorage.setItem('h-access_token', '');
        localStorage.setItem('h-expires_in', '');
        localStorage.setItem('lastActvity', '');
        localStorage.setItem('prev_route', '');
        window.location.reload()
    }, [])

    return null
}

export default AutoLogout